import { render, staticRenderFns } from "./GrantBtns.vue?vue&type=template&id=21cbd248&"
import script from "./GrantBtns.vue?vue&type=script&lang=js&"
export * from "./GrantBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports